import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "14", height: "6", x: "5", y: "16", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "10", height: "6", x: "7", y: "2", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 12h20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignVerticalJustifyCenter";
const AlignVerticalJustifyCenter = memo(themed(Icon));
export {
  AlignVerticalJustifyCenter
};
//# sourceMappingURL=align-vertical-justify-center.js.map
